import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { LogOut, ShieldCheck, ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";

export default function Layout({ children, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;

  const onSignOut = async () => { await logout(); navigate("/login"); };
  const isAdmin = user.role === "admin";

  return (
    <div className="min-h-screen bg-[#0a0e1a] text-slate-100 flex flex-col">
      <header className="sticky top-0 z-40 border-b hairline bg-[#0a0e1a]/90 backdrop-blur">
        <div className="max-w-[1600px] mx-auto px-4 md:px-6 py-3 flex items-center gap-3">
          <Link
            to="/hub"
            data-testid="back-to-hub"
            className="flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="hidden sm:inline">Back to Hub</span>
          </Link>
          <div className="w-px h-6 bg-slate-800 mx-1 hidden sm:block" />
          <div className="flex items-center gap-2.5 min-w-0">
            <div className="w-8 h-8 rounded-md bg-blue-600/90 flex items-center justify-center shrink-0">
              <ShieldCheck className="w-4 h-4 text-white" />
            </div>
            <div className="leading-tight min-w-0">
              <div className="text-sm font-semibold tracking-tight truncate">
                {title || "Mercy Management System"}
              </div>
              <div className="text-[10px] text-slate-500 num hidden md:block">Licence JTKSM 928</div>
            </div>
            <span className={`ml-1 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider num
              ${isAdmin ? "bg-emerald-500/15 text-emerald-300 border border-emerald-500/30"
                        : "bg-slate-500/10 text-slate-300 border border-slate-500/30"}`}>
              {isAdmin ? "Admin" : "Staff"}
            </span>
          </div>
          <div className="flex-1" />
          <div className="flex items-center gap-2">
            <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full border hairline surface-2" data-testid="user-badge">
              <span className="w-2.5 h-2.5 rounded-full" style={{ background: user.color }} />
              <span className="text-sm">{user.display_name}</span>
            </div>
            <Button variant="ghost" size="sm" onClick={onSignOut}
              className="text-slate-300 hover:text-white hover:bg-white/5" data-testid="sign-out-button">
              <LogOut className="w-4 h-4 mr-1.5" /> Sign out
            </Button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-[1600px] mx-auto w-full px-3 md:px-6 py-5">
        {children}
      </main>

      <footer className="border-t hairline py-3 text-[11px] text-slate-500 num text-center">
        Mercy Management System
      </footer>
    </div>
  );
}
